import {
  Box,
  Dialog,
  Flex,
  HStack,
  Portal,
  Text,
  VStack,
} from '@chakra-ui/react';
import { ReactComponent as DownIcon } from 'assets/icons/chevron-down.svg';
import { ReactComponent as TransferIcon } from 'assets/icons/transfer.svg';
import { useTranslation } from 'localization';

import {
  Button,
  DIALOG_ACTION_BUTTON_PROPS,
  SERVICE_FLOW_BORDER,
  ServiceDialogBody,
  ServiceDialogCloseTrigger,
  ServiceDialogFooter,
  ServiceDialogHeader,
  serviceDialogShellProps,
} from 'components';

type ApproveModalType = {
  onClose: () => void;
  isOpen: boolean;
  loading: boolean;
  data: { amount: number; fee: number };
  onButton: () => void;
};

const ApproveModal: React.FC<ApproveModalType> = ({
  onClose,
  isOpen,
  data,
  loading,
  onButton,
}: ApproveModalType) => {
  const { t } = useTranslation('component.transfer.modal');

  const feeAmount = (data.amount * data.fee) / 100;

  return (
    <Box display="flex" alignItems="center">
      <Dialog.Root
        size="md"
        open={isOpen}
        placement="center"
        onOpenChange={(e: { open: boolean }) => {
          if (!e.open) {
            onClose();
          }
        }}
      >
        <Portal>
          <Dialog.Backdrop />
          <Dialog.Positioner>
            <Dialog.Content {...serviceDialogShellProps()}>
              <ServiceDialogHeader>{t('confirm')}</ServiceDialogHeader>
              <ServiceDialogCloseTrigger />
              <ServiceDialogBody>
                <VStack
                  align="center"
                  justify="space-between"
                  h="100%"
                  w="100%"
                >
                  <VStack w="100%" align="center" justify="center">
                    <TransferIcon />
                    <Text fontSize="4xl" fontWeight="500" color="body2" py={2}>
                      $ {data.amount}
                    </Text>
                    <DownIcon />
                    <Text fontSize="4xl" fontWeight="500" color="body">
                      $ {data.amount - feeAmount}
                    </Text>
                  </VStack>
                  <Box
                    w="100%"
                    mt={2}
                    rounded="md"
                    borderWidth="1px"
                    borderColor={SERVICE_FLOW_BORDER}
                    bg="dark"
                    px={{ base: 3, md: 4 }}
                    py={1}
                  >
                    <Flex justify="space-between" align="center" gap={4} py={3}>
                      <Text fontSize="sm" color="body2" flexShrink={0}>
                        {t('fee')}
                      </Text>
                      <Text
                        fontSize="sm"
                        color="body"
                        textAlign="right"
                        flex="1"
                        minW={0}
                      >
                        {data.fee ? '% ' + data.fee : '0'}
                      </Text>
                    </Flex>
                  </Box>
                </VStack>
              </ServiceDialogBody>
              <ServiceDialogFooter>
                <HStack justifyContent="flex-end" gap={2} flexWrap="wrap">
                  <Button
                    variant="ghost"
                    title={t('cancel')}
                    onClick={onClose}
                    {...DIALOG_ACTION_BUTTON_PROPS}
                  />
                  <Button
                    variant="filled"
                    title={t('confirm')}
                    isLoading={loading}
                    onClick={() => onButton()}
                    {...DIALOG_ACTION_BUTTON_PROPS}
                  />
                </HStack>
              </ServiceDialogFooter>
            </Dialog.Content>
          </Dialog.Positioner>
        </Portal>
      </Dialog.Root>
    </Box>
  );
};

export default ApproveModal;
